import React from 'react';
import { User, Calendar, Heart, Smile } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function PersonalTraining() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  const benefits = [{
    icon: User,
    text: 'Persönliche Betreuung'
  }, {
    icon: Calendar,
    text: 'Flexible Terminwahl'
  }, {
    icon: Heart,
    text: 'Schmerzreduktion'
  }, {
    icon: Smile,
    text: 'Stressabbau'
  }];
  return <section id="personal-training" className="relative py-32 bg-dark-studio overflow-hidden" data-id="element-158">
      {/* Top Wave SVG */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-[0]" data-id="element-159">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-[calc(100%+1.3px)] h-[60px] fill-white" data-id="element-160">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" data-id="element-161"></path>
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-162">
        <div ref={ref} className="flex flex-col lg:flex-row items-center justify-between gap-16" data-id="element-163">
          {/* Text Content */}
          <div className={`lg:w-1/2 ${isVisible ? 'animate-slide-in-left' : 'opacity-0'}`} data-id="element-164">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-165">
              Individuelles <br data-id="element-166" />
              <span className="text-peony-400" data-id="element-167">Personal Training</span>
            </h2>
            <p className="text-gray-300 text-lg mb-8 leading-relaxed" data-id="element-168">
              Erreiche deine Ziele schneller und effektiver mit einem auf dich
              zugeschnittenen Trainingsplan. Egal ob du flexibler werden,
              Schmerzen lindern oder einfach fitter werden möchtest – wir
              begleiten dich auf deinem Weg.
            </p>

            <div className="inline-block bg-white/10 backdrop-blur-md border border-peony-500/30 rounded-2xl p-6 mb-8" data-id="element-169">
              <span className="block text-gray-300 text-sm uppercase tracking-wider mb-1" data-id="element-170">
                Startpreis
              </span>
              <span className="text-4xl font-bold text-peony-400 drop-shadow-[0_0_10px_rgba(238,120,152,0.5)]" data-id="element-171">
                ab 65 €{' '}
                <span className="text-xl text-gray-400 font-normal" data-id="element-172">
                  / Stunde
                </span>
              </span>
            </div>

            <button className="btn-primary w-full sm:w-auto" data-id="element-173">
              Personal Training anfragen
            </button>
          </div>

          {/* Benefits Grid */}
          <div className={`lg:w-1/2 space-y-6 ${isVisible ? 'animate-slide-in-right' : 'opacity-0'}`} data-id="element-174">
            {/* Studio photo accent */}
            <div className="relative rounded-2xl overflow-hidden h-48 shadow-xl" data-id="element-175">
              <img src="https://cdn.magicpatterns.com/uploads/5gza5v5xYCZUhqmT8tcb49/image00116.jpg" alt="Flex Club Yoga Block" className="w-full h-full object-cover object-center" data-id="element-176" />
              <div className="absolute inset-0 bg-gradient-to-r from-dark-studio/60 to-transparent flex items-center px-6" data-id="element-177">
                <p className="text-white font-bold text-lg leading-snug" data-id="element-178">
                  Dein Studio.
                  <br data-id="element-179" />
                  Deine Ausrüstung.
                </p>
              </div>
            </div>

            {/* Benefits */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-180">
              {benefits.map((benefit, index) => <div key={index} className="bg-dark-surface p-6 rounded-xl border border-white/5 hover:border-peony-500/50 transition-colors duration-300 flex flex-col items-center text-center group" data-id="element-181">
                  <div className="w-14 h-14 rounded-full bg-peony-500/10 flex items-center justify-center mb-4 group-hover:bg-peony-500 group-hover:text-white transition-all duration-300 text-peony-400" data-id="element-182">
                    <benefit.icon size={28} data-id="element-183" />
                  </div>
                  <h3 className="text-white font-medium text-lg" data-id="element-184">
                    {benefit.text}
                  </h3>
                </div>)}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Wave SVG */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-[0]" data-id="element-185">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-[calc(100%+1.3px)] h-[60px] fill-white transform rotate-180" data-id="element-186">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" data-id="element-187"></path>
        </svg>
      </div>
    </section>;
}